import React, {useContext, useMemo, useState} from 'react';
import * as PropTypes from 'prop-types';
import VisibilitySensor from 'react-visibility-sensor/visibility-sensor';

import Icon from '@components/icon';
import Tooltip from '@components/tooltip';
import { classes } from 'as-ui-kit/utils/styles';

import styles from './styles.modules.scss';
import i18nStrings from './strings';
import { useLocalized } from 'utils/useLocalized';
import LockedFirmInfo from '../../LockedFirmInfo';
import FirmGraph from '../../FirmGraph';
import ActualTrucks from '../../ActualTrucks';
import FirmActionDropdown from './FirmActionDropdown';
import FirmInfo from '../../FirmInfo';
import Checkbox from '@components/checkbox';
import {DataContext} from 'contexts';
import Contacts from 'components/Page/SearchResults/Contacts';

const ResultElement = ({num, value, icon, onChangeVisibility}) => {
    const strings = useLocalized(i18nStrings);
    const isSpecialElement = useMemo(() => num === 1 && !value.id, [num, value]);
    const { handleSearchResultSelection, isUser, licenseInfo } = useContext(DataContext);

    const [isVisible, setIsVisible] = useState(false);

    const handleChange = (visible) => {
        if (value.id && !isVisible && visible) {
            setIsVisible(true);
            onChangeVisibility(value.id);
        }
    };

    return (
        <div className={classes(styles['wrapper'], (isSpecialElement && styles['special-element']))}>
            <VisibilitySensor onChange={handleChange}>
                <>
                    {!value.visibleNumber && (<div className={styles['top-firm-line']}/>)}
                    <div className={styles['element']}>
                        <div className={styles['header']}>
	                        <div className={styles['checkbox-and-number']}>
		                        <Checkbox
			                        checked={value.isSelected}
			                        className={styles['checkbox']}
			                        disabled={!isUser || !value.id}
			                        size="small"
			                        onChange={event => handleSearchResultSelection(value.id, event.target.checked)}
		                        />
		                        {!value.visibleNumber ? (
			                        <Icon
				                        color="#64B82A"
				                        name="ic_pointer-arrow-up"
				                        size="m"
			                        />
		                        ) : (
			                        <span>
                                        {`#${value.visibleNumber}`}
                                    </span>
		                        )}
	                        </div>
                            {value.id && (
                                <FirmActionDropdown
                                    atiId={value.id}
                                />
                            )}
                        </div>
                        {value.id && (
                            <FirmGraph
                                graphWidth={value.graph.width}
                                trucksWidth={value.graph.truckWidth}
                            />
                        )}
                        <div className={styles['counters']}>
                            <div className={styles['parameter']}>
                                <div className={styles['name']}>
                                    {strings.actualTrucks}
                                    <Tooltip
                                        classNames={{wrapper: styles['tooltip']}}
                                        content={strings.actualTrucksTooltip}
                                        maxWidth={240}
                                    >
                                        <Icon
                                            color="#B8B8B8"
                                            name="ic_information"
                                            size="s"
                                        />
                                    </Tooltip>
                                </div>
                                <div className={styles['value']}>
                                    <ActualTrucks
                                        atiId={value.id}
                                        trucksCount={value.actualTrucksCount}
                                    />
                                </div>
                            </div>
                            <div className={styles['parameter']}>
                                <div className={styles['name']}>
                                    {strings.trucksCount}
                                    <Tooltip
                                        classNames={{wrapper: styles['tooltip']}}
                                        content={strings.trucksCountTooltip}
                                        maxWidth={240}
                                    >
                                        <Icon
                                            color="#B8B8B8"
                                            name="ic_information"
                                            size="s"
                                        />
                                    </Tooltip>
                                </div>
                                <div className={styles['value']}>
                                    {value.trucksCount}
                                </div>
                            </div>
                            <div className={styles['parameter']}>
                                <div className={styles['name']}>
                                    {strings.searchCount}
                                    <Tooltip
                                        classNames={{wrapper: styles['tooltip']}}
                                        content={strings.searchCountTooltip}
                                        maxWidth={240}
                                    >
                                        <Icon
                                            color="#B8B8B8"
                                            name="ic_information"
                                            size="s"
                                        />
                                    </Tooltip>
                                </div>
                                <div className={styles['value']}>
                                    {value.searchCount}
                                </div>
                            </div>
                        </div>
                        {value.id ? (
                            <FirmInfo
                                firm={value.firmInfo}
                                icons={icon}
                                id={value.id}
                            />
                        ) : (
                            <LockedFirmInfo
                                isFirst={num === 1}
                            />
                        )}
	                    {value.id && (
		                    <div className={styles['contacts']}>
			                    <Contacts firmId={value.id}/>
		                    </div>
	                    )}
                    </div>
                </>
            </VisibilitySensor>
        </div>
    );
};

export default ResultElement;

ResultElement.propTypes = {
    icon: PropTypes.object,
    num: PropTypes.number,
    value: PropTypes.object,
    onChangeVisibility: PropTypes.func,
};
